import { createFileRoute, Outlet } from "@tanstack/react-router";
import AdminGuard from "@/components/auth/admin-guard";
import SuperLayout from "@/components/layout/super-layout/super-layout";

export const Route = createFileRoute("/_super")({
  component: SuperAdminLayout,
});

function SuperAdminLayout() {
  return (
    <AdminGuard requireSuperAdmin={true}>
      <SuperLayout>
        <Outlet />
      </SuperLayout>
    </AdminGuard>
  );
}
